// extracted by mini-css-extract-plugin
export default {"container":"container--MonUS","annoyingBanner":"annoyingBanner--d19ar","talking":"talking--HDE8G","phonechange":"phonechange--bkCYY"};